// extracted by mini-css-extract-plugin
export var textInput = "_m3-0";